import React, { Component } from 'react'
import capitalize from 'lodash/capitalize'
import startCase from 'lodash/startCase'
import { NavLink } from 'react-router-dom'

import anonymousUser from '../../../assets/images/anonymous-user.svg'
import { User } from '../../../core/types'

export interface Props {
  user: User
  context: string
}

export class UserBannerAvatar extends Component<Props> {
  static displayName = 'UserBanner'

  render() {
    const { user, context } = this.props
    const { name, id, photo, currentAdmin, organization } = user

    const ownerName = currentAdmin?.name
      ? startCase(capitalize(currentAdmin.name))
      : null

    return (
      <div data-test="user-banner-avatar" className="user-banner__avatar">
        {photo ? (
          <img
            className="user-banner__avatar-image"
            alt=""
            src={`${photo.url}`}
          />
        ) : (
          <img
            className="user-banner__avatar-image"
            alt=""
            src={anonymousUser}
          />
        )}
        <NavLink
          className="user-banner__context-pill"
          data-test="user-banner-avatar-link"
          to={`/users/${id}`}
        >
          {context}
        </NavLink>
        <div className="user-banner__avatar-name">
          {name && startCase(capitalize(name))}
        </div>
        <p className="user-banner__avatar-user-id">{`ID ${id}`}</p>
        {ownerName && (
          <p className="user-banner__avatar-user-id">{`Owner: ${ownerName}`}</p>
        )}

        {organization && (
          <p className="user-banner__avatar-user-id">{`Organization: ${organization.nameLegal}`}</p>
        )}
      </div>
    )
  }
}
